// Constants
import { API_RESPONSE_CODE } from "UTILS/axios.init";
import { strings, ERROR, maxPdfFileSize, CUSTOMER_CO_BROWSE_ERROR } from "UTILS/Constants";
import { getMessage } from "CONFIG/i18n";

// Error look-up function for error returned from APIs
export function getAPIErrorInfo(errorCode = null, errorObject, isOnline) {
  let errorInfo = {};
  if (errorObject) {
    errorInfo.status = errorObject.status;
    switch (errorInfo.status) {
      case API_RESPONSE_CODE.BAD_REQUEST:
        errorInfo.message = getMessage(errorObject.data.error.code);
        errorInfo.code = errorObject.data.error.code;
        errorInfo.title = getMessage("Error");
        if ('details' in errorObject.data.error) {
          errorInfo.details = { ...errorObject.data.error.details };
        }
        break;
      case API_RESPONSE_CODE.UNAUTHORIZED_USER:
        errorInfo.message = getMessage(errorObject.data.error.code);
        errorInfo.code = errorObject.data.error.code;
        errorInfo.title = getMessage("Error");
        break;
      case API_RESPONSE_CODE.FORBIDDEN:
        errorInfo.message = getMessage(errorObject.data.error.code);
        errorInfo.code = errorObject.data.error.code;
        errorInfo.title = getMessage("Error");
        break;
      case API_RESPONSE_CODE.INTERNAL_SERVER_ERROR:
        errorInfo.message = getMessage(errorObject.data.error.code);
        errorInfo.code = errorObject.data.error.code;
        errorInfo.title = getMessage("Error");
        break;
      case API_RESPONSE_CODE.NOT_FOUND:
        errorInfo.message = getMessage(strings.ResourceNotFound);
        errorInfo.code = errorObject.data.error.code;
        errorInfo.title = getMessage("Error");
        break;
      case API_RESPONSE_CODE.PAYLOAD_TOO_LARGE:
        errorInfo.message = getMessage(ERROR.FILE_SIZE_EXCEEDS_LIMIT , {size:Math.round((maxPdfFileSize/1000000))});
        errorInfo.code = ERROR.FILE_SIZE_EXCEEDS_LIMIT;
        errorInfo.title = getMessage("Error");
        break;
      case API_RESPONSE_CODE.SERVER_UNREACHABLE_ERROR:
        errorInfo.message = getMessage(ERROR.SERVER_UNREACHABLE_ERROR);
        errorInfo.code = errorObject.data.error.code;
        errorInfo.title = getMessage("Error");
        break;
      default:
        errorInfo = checkOnlineAndGetMsg(isOnline);
    }
    
    return errorInfo;
    
  } else {
    if(isOnline && errorCode === "ECONNABORTED") {
      errorInfo.message = getMessage(ERROR.REQUEST_TIMEOUT_ERROR);
      errorInfo.code = ERROR.REQUEST_TIMEOUT_ERROR;
      errorInfo.title = getMessage("Error");
      return errorInfo;
    }
    return checkOnlineAndGetMsg(isOnline);
  }
}

export function getCoBrowseAPIErrorInfo(errorObject, isOnline) {
  let errorInfo = {};
  if(errorObject) {
    errorInfo.status = errorObject.status;
    switch (errorInfo.status) {
      case API_RESPONSE_CODE.BAD_REQUEST:
        errorInfo.message = errorObject.data.message;
        errorInfo.code = CUSTOMER_CO_BROWSE_ERROR[errorObject.data.code];
        errorInfo.title = getMessage("Error");
        break;
      default:
        errorInfo = checkOnlineAndGetMsg(isOnline);
    }
    return errorInfo;
  } else {
    if(isOnline && errorObject.code === "ECONNABORTED") {
      errorInfo.message = getMessage(ERROR.REQUEST_TIMEOUT_ERROR);
      errorInfo.code = ERROR.REQUEST_TIMEOUT_ERROR;
      errorInfo.title = getMessage("Error");
      return errorInfo;
    }
    return checkOnlineAndGetMsg(isOnline);
  }
}

function checkOnlineAndGetMsg (isOnline) {
  return isOnline ? 
    {
      status: ERROR.SERVER_UNREACHABLE_ERROR,
      message: getMessage(ERROR.SERVER_UNREACHABLE_ERROR),
      title: getMessage("Error"),
      code: ERROR.SERVER_UNREACHABLE_ERROR
    }
    : 
    {
      status: "NETWORK_ERROR",
      message: getMessage(ERROR.NETWORK_ERROR),
      title: getMessage("Error"),
      code: ERROR.NETWORK_ERROR
    };
}
